import { isEqual } from "lodash";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import MdaeTextBox from "../../../common_components/common_widgets/text-box/component";
import { checkIsPermOrQioReviewContractor } from "../../../pages/external-audit/case-detail/case-data/component";
import MdaeSelectBox from "../../common_widgets/select-box/component";
import { SET_SUBMISSION_CONTENT_TYPE } from "./reducers/esmd-submission-reducer";

const EsmdSubmissionDetails: React.FC<any> = (props) => {
  const dispatch = useDispatch();
  const currentEaRound = useSelector(
    (state) => state["externalAuditReducer"].eaAuditRounds[0],
    isEqual
  );
  const caseData = useSelector(
    (state) => state["caseDataReducer"].caseData,
    isEqual
  );
  const submissionEaContentTypeId = useSelector(
    (state) => state["esmdSubmissionReducer"].eaContentTypeId,
    isEqual
  );
  const onContentTypeClick = () => {
    window.open("/externalaudit/admin/contenttypes", "_blank");
  };
  const auditPropertiesData = useSelector(
    (state) => state["auditPropertiesReducer"].auditPropertiesData,
    isEqual
  );
  const validContentTypes = useSelector(
    (state) => state["externalAuditReducer"].validContentTypes,
    isEqual
  );
  const contentTypeList = useSelector(
    (state) => state["esmdSubmissionReducer"].contentTypeList,
    isEqual
  );
  const isCurrentRequesterReviewContractorValid = useSelector(
    (state) =>
      state["externalAuditReducer"].isCurrentRequesterReviewContractorValid,
    isEqual
  );
  const isCurrentContentTypeInvalidForReviewContractor = useSelector(
    (state) =>
      state["externalAuditReducer"]
        .isCurrentContentTypeInvalidForReviewContractor,
    isEqual
  );
  let finalValueObject = null;
  if (props.isFromTrackSubmissionTab) {
    finalValueObject = {
      requesterName: props.submittedDocumentHeaderData?.eaRequesterName,
      submissionEaContentTypeId:
        props.submittedDocumentHeaderData?.eaContentTypeId,
      referenceId: props.submittedDocumentHeaderData?.referenceId,
      rqstrRecordSubmissionMethodDisplayName:
        props.submittedDocumentHeaderData
          ?.rqstrRecordSubmissionMethodDisplayName,
      rqstrRecordSubmissionValue:
        props.submittedDocumentHeaderData?.reviewContractorCode,
      payerCaseId: props.submittedDocumentHeaderData?.payerCaseId,
      roundSubmittedSequenceNos:parseInt(props.submittedDocumentHeaderData?.roundSubmittedSequenceNos)
    };
  } else {
    finalValueObject = {
      requesterName: caseData?.rqstrContactName,
      submissionEaContentTypeId: submissionEaContentTypeId,
      referenceId: auditPropertiesData?.referenceId,
      rqstrRecordSubmissionMethodDisplayName:
      caseData?.rqstrRecordSubmissionMethodDisplayName,
      rqstrRecordSubmissionValue: caseData?.rqstrRecordSubmissionValue,
      payerCaseId: caseData.payerCaseId,
      roundSubmittedSequenceNos:caseData?.sequenceNo
    };
  }
  const isPermOrQioReviewContractor = checkIsPermOrQioReviewContractor(
    caseData?.rqstrRecordSubmissionValue
  );

  const AuditPropertiesSection = () => {
    return (
      <div>
        <div className="section-style">
          <MdaeTextBox
            id={"txtRequester"}
            readOnly={true}
            mdaeTextBoxTitle={"Requester"}
            value={finalValueObject.requesterName}
            width={400}
          ></MdaeTextBox>
          <div className="content-type-field">
            <MdaeSelectBox
              id={"ddlContentType"}
              mdaeDropDownBoxTitle={"Content Type"}
              required
              width={377}
              className={isCurrentContentTypeInvalidForReviewContractor || currentEaRound?.sequenceNo != finalValueObject?.roundSubmittedSequenceNos?"":"invalid-content-type-for-requester"}
              dataSource={
                props.isFromTrackSubmissionTab
                  ? contentTypeList
                  : validContentTypes
              }
              isValid={isCurrentContentTypeInvalidForReviewContractor || currentEaRound?.sequenceNo != finalValueObject?.roundSubmittedSequenceNos}
              elementAttr={{
                title: isCurrentContentTypeInvalidForReviewContractor || currentEaRound?.sequenceNo != finalValueObject?.roundSubmittedSequenceNos
                  ? ""
                  : "The selected Content Type is no longer valid for the Review Contractor associated with this Requester. Please update your Content Type selection.",
              }}
              itemRender={(item) => {
                if (item.activeInd) {
                  return (
                    item &&
                    item.eaContentTypeCode +
                      " - " +
                      item.eaContentTypeDescription
                  );
                }
              }}
              disabled={props.isFromTrackSubmissionTab}
              valueExpr={"eaContentTypeId"}
              displayExpr={(item) => {
                return (
                  item &&
                  item.eaContentTypeCode + " - " + item.eaContentTypeDescription
                );
              }}
              onContentReady={(e) => {
                if (submissionEaContentTypeId <= 0) {
                  dispatch({
                    type: SET_SUBMISSION_CONTENT_TYPE,
                    data: caseData?.eaContentTypeId,
                  });
                }
              }}
              onValueChanged={(e) => {
                dispatch({
                  type: SET_SUBMISSION_CONTENT_TYPE,
                  data: e.value,
                });
              }}
              value={finalValueObject.submissionEaContentTypeId}
            ></MdaeSelectBox>
            <span
              className="case-search-info-icon content-type-field-icon"
              title={
                "Click here to open the Content Maintenance page for more information"
              }
              onClick={onContentTypeClick}
            >
              <i className="img-circle fa fa-info-circle account-case-search-info-circle"></i>
            </span>
          </div>
          <MdaeTextBox
            id={"txtReferenceId"}
            readOnly={true}
            mdaeTextBoxTitle={"Reference ID"}
            value={finalValueObject.referenceId}
            width={400}
          ></MdaeTextBox>
        </div>
        <div className="section-style">
          <MdaeTextBox
            id={"txtSubmissionMethod"}
            readOnly={true}
            mdaeTextBoxTitle={"Record Submission Method"}
            width={400}
            value={finalValueObject?.rqstrRecordSubmissionMethodDisplayName}
          ></MdaeTextBox>
          <MdaeTextBox
            id={"txtReviewContrator"}
            readOnly={true}
            mdaeTextBoxTitle={"Review Contractor"}
            width={400}
            className={isCurrentRequesterReviewContractorValid || currentEaRound?.sequenceNo != finalValueObject?.roundSubmittedSequenceNos?"":"invalid-review-contractor"}
            isValid={isCurrentRequesterReviewContractorValid || currentEaRound?.sequenceNo != finalValueObject?.roundSubmittedSequenceNos}
            elementAttr={{
              title: isCurrentRequesterReviewContractorValid || currentEaRound?.sequenceNo != finalValueObject?.roundSubmittedSequenceNos
                ? ""
                : "This Review Contractor is no longer valid. Please select another eligible Review Contractor and update the Review Contractor for your Requester",
            }}
            value={finalValueObject?.rqstrRecordSubmissionValue}
          ></MdaeTextBox>
          <MdaeTextBox
            id={"txtPayerCaseId"}
            mdaeTextBoxTitle={
              isPermOrQioReviewContractor ? "Payer Case ID" : "Payer Claim ID"
            }
            maxLength={100}
            readOnly={true}
            width={400}
            value={finalValueObject.payerCaseId}
            elementAttr={{
              title: isPermOrQioReviewContractor
                ? "11 Alphanumeric characters (A-Z, 0-9)"
                : "8 digits, or 13 to 15 digits, or 17-23 alphanumeric characters (A-Z, a-z, 0-9, dash or space)",
            }}
          ></MdaeTextBox>
        </div>
      </div>
    );
  };
  return (
    <div>
      <AuditPropertiesSection />
    </div>
  );
};

export default EsmdSubmissionDetails;
